var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4402 4.92546C11.5075 4.03364 10.3211 3.57955 8.99976 3.57955C6.65593 3.57955 4.67203 5.16237 3.96409 7.28928V7.29001C3.78409 7.83001 3.68182 8.40683 3.68182 9.00001C3.68182 9.59319 3.78409 10.17 3.96409 10.71L3.9639 10.7102C4.67168 12.8373 6.65573 14.4204 8.99976 14.4204C10.2107 14.4204 11.2416 14.1014 12.0475 13.5614L12.0477 13.5615C13.0009 12.9232 13.635 11.97 13.8436 10.845H9V7.36365H17.4764C17.5827 7.95274 17.64 8.56637 17.64 9.20456C17.64 11.9455 16.6582 14.2527 14.9564 15.8196H14.9561C13.467 17.1941 11.4297 18 8.99976 18C5.48158 18 2.43794 15.9832 0.957031 13.0418V13.0413C0.347635 11.8265 0 10.4521 0 9.00001C0 7.54779 0.347703 6.17329 0.957208 4.95832L0.957031 4.95818C2.43794 2.01682 5.48158 0 8.99976 0C11.4257 0 13.4629 0.891818 15.0216 2.34409L12.4402 4.92546Z",
    fill: "#d0463b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.aeb4bec6c2d9102704f96eab9b016b86.svg";
export { ForwardRef as ReactComponent };